export interface IStep {
  name: string;
  title: string;
  view: boolean;
  skip: boolean;
}

export interface IToStep {
  name: string;
  title: string;
  stepName: string;
}

export enum E_TO_STEP_CUSTOM_EVENT {
  LOAD_START = 'to-step-button:load-start',
  LOAD_END = 'to-step-button:load-end',
}